import React, { useEffect, useState } from 'react';

// "21 oct": el dia de la jornada, detras de su nombre
const conFecha = (jornada) =>
    jornada.fecha
        ? `${jornada.nombre} · ${new Date(jornada.fecha + 'T12:00').toLocaleDateString('es-ES', { day: 'numeric', month: 'short' })}`
        : jornada.nombre;

// Desplegable de la clasificacion: la liga o una de las jornadas, la mas nueva
// primero. Las jornadas se crean solas, una por dia de juego; el backend manda
// las que tienen algun vino cerrado y la que se esta jugando. Sale siempre que
// haya alguna, tambien mientras se desvela una: la revelacion tapa los puntos,
// no el desplegable.
const SelectorJornada = ({ vista, onChange, recargar }) => {
    const [jornadas, setJornadas] = useState([]);

    // Se piden otra vez cuando empieza una jornada o se cierra un vino (recargar
    // cambia): la jornada nueva puede no estar todavia en la lista
    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/jornadas`)
            .then((respuesta) => (respuesta.ok ? respuesta.json() : []))
            .then(setJornadas)
            .catch(() => setJornadas([]));
    }, [recargar]);

    if (jornadas.length === 0) {
        return null;
    }

    return (
        <div className="selector-jornada">
            <select value={vista} onChange={(e) => onChange(e.target.value)} aria-label="Ver la clasificación de">
                <option value="liga">Liga</option>
                {jornadas.map((jornada) => (
                    <option key={jornada.id} value={String(jornada.id)}>{conFecha(jornada)}</option>
                ))}
            </select>
        </div>
    );
};

// La vista que se abre si no se ha elegido otra: la jornada que se esta jugando
// y, si no hay ninguna, la liga
export const vistaPorDefecto = (estado) =>
    estado && estado.en_curso ? String(estado.en_curso.id) : 'liga';

// Puntos de una fila (jugador o winegang) en la vista elegida
export const puntosEn = (vista, fila) =>
    vista === 'liga' ? fila.total_points : (fila.jornadas && fila.jornadas[vista]) || 0;

// Puntos de una fila en el ultimo vino de una jornada
export const ultimoVinoEn = (vista, fila) => (fila.ultimo_vino && fila.ultimo_vino[vista]) || 0;

// Filas de una jornada: solo quien jugo en ella, de mas a menos puntos de la
// jornada o del ultimo vino (orden 'vino')
export const filasDeJornada = (filas, vista, orden = 'jornada') => {
    const principal = orden === 'vino' ? ultimoVinoEn : puntosEn;
    const segundo = orden === 'vino' ? puntosEn : ultimoVinoEn;
    return filas
        .filter((fila) => fila.jornadas && fila.jornadas[vista] !== undefined)
        .sort((a, b) =>
            principal(vista, b) - principal(vista, a)
            || segundo(vista, b) - segundo(vista, a)
            || b.total_points - a.total_points);
};

export default SelectorJornada;
